'use client'
import {
  context_default
} from "./chunk-BEC3XFLK.mjs";

// src/context/redeem/useRedeem.ts
import { useContext } from "react";
function useRedeem() {
  const context = useContext(context_default);
  return context;
}

export {
  useRedeem
};
//# sourceMappingURL=chunk-7OO2W25G.mjs.map